export const accountOptions = [
  {
    title: "Subscription",
    link: "/app/premium",
    iconKey: "users",
    forLead: true,
  },
  {
    title: "Manage subscription-details",
    forDevEnv: false,
    link: "/app/premium",
    iconKey: "list",
  },
  {
    title: "Sign out",
    function: "logOut",
    iconKey: "logOut",
    forGuest: false,
  },
  {
    title: "Delete organization",
    function: "setIsDeleteOrganizationModalOpen",
    forLead: true,
    iconKey: "delete",
    state: { type: "team" },
  },
  {
    title: "Delete my data",
    function: "setIsDeleteModalOpen",
    iconKey: "delete",
    forLead: true,
    state: { type: "team" },
  },
  {
    title: "Delete account",
    function: "setIsDeleteModalOpen",
    iconKey: "delete",
    forLead: false,
    state: { type: "team" },
  },
];
